import React from 'react';
import { Switch, FormControlLabel } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const StyledSwitch = withStyles({
    root: {
        width: 56,
        height: 32,
        padding: 0,
    },
    switchBase: {
        padding: 4,
        '&$checked': {
            transform: 'translateX(24px)',
            color: '#fff',
            '& + $track': {
                backgroundColor: '#3C66C4',
                opacity: 1,
                border: 'none',
            },
        },
    },
    thumb: {
        width: 24,
        height: 24,
    },
    track: {
        borderRadius: 16,
        backgroundColor: '#bdbdbd',
        opacity: 1,
    },
    checked: {},
})(Switch);

/**
 * @param {{
 * label: string,
 * labelId: string, 
 * formikValue: Object, 
 * formikChange: Function, 
 * disabled:boolean,
 * errors?: formik.errors.labelId,
 * touched?: formik.touched.labelId,
 * mandatory: Boolean,
 * checked: Boolean,
 * addCheckBoxClass: String 'Add custom class to adjust checkbox'
 * }} props 
 */


export const SwitchInput = (props) => {

    return (
        <FormControlLabel
        control={
            <StyledSwitch
                checked={props.formikValue} // Pass the current value
                onChange={(event) => {
                    // Call Formik's change handler with the updated value
                    props.formikChange({
                        target: {
                            name: props.labelId,
                            value: event.target.checked,
                        },
                    });
                }}
            />
            }
            label={props.label}
        />
    )
}






